import { render, staticRenderFns } from "./SparsBrands.vue?vue&type=template&id=3de3f95a"
import script from "./SparsBrands.vue?vue&type=script&lang=js"
export * from "./SparsBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports